<template>
  <OrderIndex :platformModule="true" currentPath="/admin/orders"/>
</template>

<script>
import OrderIndex from '@/components/admin/order_flow/Index.vue'

export default {
  components: {OrderIndex},
  name: 'AdminOrdersIndex',
}
</script>
